export type SidebarPreset = 'default' | 'small-team'

// Only known secondary pages move under More. New modules keep their normal
// defaults until deliberately classified here; permissions are checked separately.
const SECONDARY_PAGES = new Set([
  '/tickets',
  '/knowledge-base',
  '/collections',
  '/forms',
  '/threads',
  '/documents',
  '/events',
  '/deals',
  '/marketing',
  '/scheduling',
  '/live-chat',
  '/quotes',
  '/products',
  '/communications',
  '/suppliers',
  '/workflows',
  '/analytics',
  '/financials',
  '/contracts',
  '/expenses',
])

export function readSidebarPreset(value: unknown): SidebarPreset {
  return value === 'small-team' ? 'small-team' : 'default'
}

export function isSidebarItemHidden(
  href: string,
  options: {
    preset?: unknown
    override?: boolean
    subscriptionLocked: boolean
  },
): boolean {
  if (typeof options.override === 'boolean') return options.override
  return (
    options.subscriptionLocked ||
    (readSidebarPreset(options.preset) === 'small-team' &&
      SECONDARY_PAGES.has(href))
  )
}
